import React from "react";
import style from "./dressingAppearance.module.scss";
import { firstLetterCaps, signedLockedAccess } from "../../../../utils";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";
import { PERMISSIONS } from "../../../../constants/permissions";
import { Row } from "../../../secondary/Row/Row";

export const DressingAppearanceViewMode = ({ resp, assessmentDetails, onEdit, isReadOnly, hasPermission }) => (
  <>
    {isReadOnly && (
      <div className={style.read_only}>
        <ReadOnlyBanner />
      </div>
    )}
    <div className={`${style.form_container}`}>
      <div className={style.form_actions}>
        <button
          type="button"
          className={style.form_edit_btn}
          onClick={onEdit}
          disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT) || !signedLockedAccess(assessmentDetails?.assessmentStage)}
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
          Edit
        </button>
      </div>

      <section className={style.form_section}>
        <div className={style.form_section_header}>
          <span className={style.form_section_title}>Dressing Appearance</span>
        </div>
        <div className={style.form_section_body}>
          <Row label="Dressing Appearance" value={firstLetterCaps(resp?.dressingAppearance)} />
        </div>
      </section>
    </div>
  </>
);
